import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './ContactPage.scss';
import Header from '../../components/ActivePath/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhoneAlt, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';

const ContactPage: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div className="contact-page">
        <Header pageTitle="" breadcrumb="Contact Us" />
      {/* Header Section */}
      <div className="header" data-aos="fade-up">
        <h1>Contact Us</h1>
        <p>We are here to assist you! Reach out for any queries, and we will get back to you as soon as possible.</p>
      </div>

      {/* Contact Information Section */}
      <div className="contact-section" data-aos="fade-up">
        <div className="cards-container">
          {/* Address Card */}
          <div className="card contact-info" data-aos="zoom-in-up">
            <div className="card-header">
              <h2>Our Address</h2>
            </div>
            <div className="card-body">
              <p><FontAwesomeIcon icon={faMapMarkerAlt} /> Sri Jagadguru Murugharajendra Polytechnic (SJMP)</p>
              <p>Birur, Karnataka, India</p>
              <p>Postal Code: 577 116</p>
            </div>
          </div>

          {/* Contact Details Card */}
          <div className="card contact-details" data-aos="zoom-in-up">
            <div className="card-header">
              <h2>Contact Details</h2>
            </div>
            <div className="card-body">
              <p><FontAwesomeIcon icon={faPhoneAlt} /><strong> Phone:</strong> (+08267) 295302</p>
              <p><FontAwesomeIcon icon={faPhoneAlt} /><strong> Phone:</strong> (+91) 9036447506</p>
              <p><FontAwesomeIcon icon={faEnvelope} /><strong> Email:</strong> 353sjmpbirur@gmail.com</p>
            </div>
          </div>

          {/* Office Hours Card */}
          <div className="card office-hours" data-aos="zoom-in-up">
            <div className="card-header">
              <h2>Office Hours</h2>
            </div>
            <div className="card-body">
              <p><FontAwesomeIcon icon={faClock} /> Monday to Friday: 9:30 AM - 5:30 PM</p>
              <p><FontAwesomeIcon icon={faClock} /> Saturday: 09.30 AM – 1.30 PM</p>
            </div>
          </div>

          {/* Contact Map Card */}
          <div className="card contact-map" data-aos="zoom-in-up">
            <div className="card-header">
              <h2>Our Location</h2>
            </div>
            <div className="card-body">
              <div className="map-container">
                {/* Embed Google Map here */}
                <iframe
                  title="SJMP Location"
                  width="100%"
                  height="250"
                  frameBorder="0"
                  style={{ border: '0' }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3877.899689255035!2d75.96888221094707!3d13.602938300666885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbae9d9b17d6db7%3A0xc7fc3959df823f83!2sSJM%20POLYTECHNIC%20(GOVT.%20AIDED)%2C%20BIRUR!5e0!3m2!1sen!2sin!4v1733658733855!5m2!1sen!2sin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
